import React from 'react';

const Newlines = ({ children }) => {
  const lines = children.split(/\n/i);

  return (
    <>
      {lines.map((l, i) => (
        <div key={i}>
          {l || <>&nbsp;</>}
        </div>
      ))}
    </>
  );
};

export default Newlines;
